import React from 'react';
import { Link } from 'react-router-dom';

import classes from './NotificationList.module.css';

import Button from '../../components/UI/Button/Button';
import FilterSection from '../../components/UI/NotificationFilterSectionNew/NotificationFilterSectionNew';
// import RouterEndPoints from '../../utilities/RouteEndPoints';
import { IsListEmpty, IsStringEmpty } from '../../utilities/CommonMethods';
import RouteEndPoints from '../../utilities/RouteEndPoints';
class NotificationList extends React.Component {

    state = {
        filterCategories: [
            // { id: 0, label: 'All', type: 'all' },
            { id: 0, label: 'Announcements', type: 'announcement', count: 0 },
            { id: 1, label: 'Notifications', type: 'notification', count: 0 },
            { id: 2, label: 'Important', type: 'important', count: 0 }
        ],
        activeItem: 0,
        activeNotificationType: 'all',
        activeNotificationsList: [],
        unreadNotifCountTotal: 0,
        unreadNotifCountAnnouncement: 0,
        unreadNotifCountImportant: 0,
        unreadNotifCountNotification: 0,

    }

    onNotificationTypeClicked = (pos) => {
        // if (pos !== this.state.activeItem && pos !== -1) {

        //     const activeType = this.state.filterCategories[pos].type;
        //     const activeId = this.state.filterCategories[pos].id;

        //     let updatedNotifList = [];
        //     for (var i = 0; i < this.state.notifications.length; i++) {
        //         let currentNotifList = [...this.state.notifications];
        //         updatedNotifList = currentNotifList.filter(notificationItem => {

        //             return activeType === 'all' ? true : notificationItem.filterCategories === activeType;
        //         })
        //     }

        //     this.setState({
        //         activeItem: pos, activeNotificationType: activeType, activeCategoryId: activeId, showLoader: false,
        //         activeNotificationsList: updatedNotifList
        //     });
        // }
    }

    componentDidMount() {

        let updatedFilterCategories = [...this.state.filterCategories];
        updatedFilterCategories[0].count = this.props.notifications.unreadNotifCountAnnouncement;
        updatedFilterCategories[1].count = this.props.notifications.unreadNotifCountNotification;
        updatedFilterCategories[2].count = this.props.notifications.unreadNotifCountImportant;

        this.setState({
            notifications: this.props.notifications.notificationsList,
            activeNotificationsList: this.props.notifications.notificationsList,
            unreadNotifCountTotal: this.props.notifications.unreadNotifCountTotal,
            unreadNotifCountAnnouncement: this.props.notifications.unreadNotifCountAnnouncement,
            unreadNotifCountImportant: this.props.notifications.unreadNotifCountImportant,
            unreadNotifCountNotification: this.props.notifications.unreadNotifCountNotification,
            filterCategories: updatedFilterCategories
        })

    }

    render() {
        const notifications = this.state.activeNotificationsList !== undefined && this.state.activeNotificationsList.length > 0 ? this.state.activeNotificationsList.slice(0, 5).map((item, pos) => {
            // let parsedURl = item.url;
            return (
                <>
                    {
                        !IsStringEmpty(item.url)
                            ? item.url.indexOf('https://') > -1 || item.url.indexOf('http://') > -1 || item.url.indexOf('www.') > -1
                                ? <a href={item.url} className={classes.RemoveTextDecoration} onClick={() => this.props.onItemClick(item.id, item.viewed, pos)}>
                                    <div key={item.label} className={!item.viewed ? [classes.item, classes.itemViewed].join(' ') : classes.item}>
                                        {/* <span className={!item.viewed ? classes.UnreadDot : null}></span> */}
                                        <img src={item.notificationIcon} alt="Notification Icon" className={classes.NotificationIcon} />
                                        {/* <p className={classes.NotificationTag}>{item.tag}</p> */}
                                        <p className={classes.NotificationMessage}>{item.label}</p>
                                        <div className={classes.ButtonContainer}>
                                            {
                                                !IsStringEmpty(item.cta)
                                                    ? <Button
                                                        label={item.cta}
                                                        styleclass="RoundSquareCorners  NoticeBoardCardButtonList"
                                                        margin="0"
                                                        padding="0"
                                                        fontSize="0.675em"
                                                    />
                                                    : null
                                            }
                                            <p className={classes.NotificationTime}>{item.time}</p>
                                        </div>

                                    </div>
                                </a>
                                : <Link to={RouteEndPoints.HOME_PAGE + item.url} className={classes.RemoveTextDecoration} onClick={() => this.props.onItemClick(item.id, item.viewed, pos)}>
                                    <div key={item.label} className={!item.viewed ? [classes.item, classes.itemViewed].join(' ') : classes.item}>
                                        {/* <span className={!item.viewed ? classes.UnreadDot : null}></span> */}
                                        <img src={item.notificationIcon} alt="Notification Icon" className={classes.NotificationIcon} />
                                        {/* <p className={classes.NotificationTag}>{item.tag}</p> */}
                                        <p className={classes.NotificationMessage}>{item.label}</p>
                                        <div className={classes.ButtonContainer}>
                                            {
                                                !IsStringEmpty(item.cta)
                                                    ? <Button
                                                        label={item.cta}
                                                        styleclass="RoundSquareCorners  NoticeBoardCardButtonList"
                                                        margin="0"
                                                        padding="0"
                                                        fontSize="0.675em"
                                                    />
                                                    : null
                                            }
                                            <p className={classes.NotificationTime}>{item.time}</p>
                                        </div>

                                    </div>
                                </Link>
                            : <div key={item.label} className={!item.viewed ? [classes.item, classes.itemViewed].join(' ') : classes.item} onClick={() => this.props.onItemClick(item.id, item.viewed, pos)}>
                                <img src={item.notificationIcon} alt="Notification Icon" className={classes.NotificationIcon} />
                                <p className={classes.NotificationMessage}>{item.label}</p>
                                <div className={classes.ButtonContainer}>
                                    {
                                        !IsStringEmpty(item.cta)
                                            ? <Button
                                                label={item.cta}
                                                styleclass="RoundSquareCorners  NoticeBoardCardButtonList"
                                                margin="0"
                                                padding="0"
                                                fontSize="0.675em"
                                            />
                                            : null
                                    }
                                    <p className={classes.NotificationTime}>{item.time}</p>
                                </div>

                            </div>
                    }

                </>
            );

            // return (
            //     <div key={pos}>
            //         <Link to={item.url} className={classes.item} onClick={() => this.props.onItemClick(item.id, item.viewed, pos)}>
            //             <div className={classes.NotificationListItem}>
            //                 <img className={classes.NotificationIcon} src={item.notificationIcon} alt="Notification Icon" />

            //                 <div>
            //                     <p className={classes.Message}>{item.label}</p>
            //                     <span className={classes.Time}>{item.time}</span>
            //                 </div>
            //             </div>
            //         </Link>

            //         <div className={classes.HorizontalSeparator}></div>
            //     </div>
            // )
        }) : <p className={classes.NoNotificationsFound}>Hey! All caught up :)</p>
        return (
            <div className={classes.NotificationList}>
                <div className={classes.NotificationTopContainer}>
                    <div className={classes.HeadingDiv}>
                        <h1 className={classes.NotificationsListHeading}>Your Notifications</h1>
                        {
                            !IsListEmpty(this.state.notifications) && this.state.notifications.length >= 5 ?
                                <p className={classes.ViewAll} onClick={this.props.onViewAllClick}>VIEW ALL</p>
                                : null
                        }
                    </div>
                    <FilterSection
                        filterCategories={this.state.filterCategories}
                        activeItemPos={this.state.activeItem}
                        activeCategoryLabel={this.state.activeNotificationType}
                        onCategoryItemClick={this.onNotificationTypeClicked}
                        notificationsDropDown={true}
                    />
                </div>
                {notifications}

                {
                    !IsListEmpty(this.state.notifications) && this.state.notifications.length >= 5 ?
                        <div className={classes.BottomViewAll}>
                            <span onClick={this.props.onViewAllClick}>VIEW ALL</span>
                        </div>

                        : null
                }
            </div>
        );
    }
}

export default NotificationList;